import { selectSessionId } from '../slices/session.slice';
import { SessionState } from '../../types/session';
import { Bank, BankCountry } from '../../services/interfaces/bank.interface';
import { ChooseBankData } from '../../services/interfaces/session.interface';
import { getSessionService } from '../../services/service.factory';
import { createAppAsyncThunk } from '../createAppAsyncThunk';
import { FincredibleBankException } from '../../types/exceptions';

interface ChooseBankActionData {
	bank: Bank;
	country: BankCountry;
}

interface ChooseBankActionFulfilledData extends ChooseBankActionData {
	nextSessionState: SessionState;
}

export const chooseBank = createAppAsyncThunk<ChooseBankActionFulfilledData, ChooseBankActionData>(
	'session/chooseBank',
	async ({ bank, country }, { getState, dispatch, rejectWithValue }) => {
		const state = getState();
		const sessionId = selectSessionId(state);
		if (!sessionId) throw new Error('Session id not defined on choose bank action');

		const data = createSelectionQuery(bank, country);
		const service = getSessionService(state.configuration.bankIntegrationVendor);
		try {
			const nextState = await service.chooseBank(sessionId, data);

			return {
				bank,
				country,
				nextSessionState: nextState
			};
		} catch (error: any) {
			if (error instanceof FincredibleBankException) {
				return rejectWithValue({
					errorKey: error.errorKey,
					context: error.context,
					reference: error.reference,
					traceId: error.traceId
				});
			}
			throw error;
		}
	}
);

const createSelectionQuery = (bank: Bank, country: BankCountry): ChooseBankData => {
	const bankCode = bank.bankCodes[0];
	return {
		bankId: bank.id,
		bankCode,
		countryCode: country
	};
};
